/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthData, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataFromJSONTyped, FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataToJSON, } from './FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthData';
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataFromJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthData(json)) {
        return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataToJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthData(value)) {
        return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseData.js.map